import { Modal } from '@vinted/web-ui';
import ExtraServicePaymentAuth from './ExtraServicePaymentAuth';
import { jsx as _jsx } from "react/jsx-runtime";

const ExtraServicePaymentAuthModal = _ref => {
  let {
    show,
    onError,
    onCancel,
    onAuthSubmitted
  } = _ref;
  return /*#__PURE__*/_jsx(Modal, {
    show: show,
    children: /*#__PURE__*/_jsx(ExtraServicePaymentAuth, {
      onAuthSubmitted: onAuthSubmitted,
      onCancel: onCancel,
      onError: onError
    })
  });
};

export default ExtraServicePaymentAuthModal;